import { useEffect, useRef, useState } from 'react';

import { useDataInsights } from '@/modules/InsightsModule/hooks/useDataInsights';

export const useOnboardingStatus = (): [boolean | null, boolean] => {
  const [shouldShowOnboarding, setShouldShowOnboarding] = useState<boolean | null>(null);
  const [hasError, setHasError] = useState(false);
  const hasRunOnce = useRef(false);
  const {
    events: { getOnboardingStatus },
  } = useDataInsights();

  useEffect(() => {
    if (hasRunOnce.current) return;
    hasRunOnce.current = true;

    const checkOnboardingStatus = async () => {
      try {
        const response = await getOnboardingStatus();

        if (response && typeof response.shouldShowOnboarding === 'boolean') {
          setShouldShowOnboarding(response.shouldShowOnboarding);
          setHasError(false);
        } else {
          setHasError(true);
        }
      } catch (error) {
        console.error('Error checking onboarding status:', error);
        setHasError(true);
      }
    };

    void checkOnboardingStatus();
  }, [getOnboardingStatus]);

  return [shouldShowOnboarding, hasError];
};
